const chalk = require("chalk");

exports.command = 'firmware <command>'
exports.desc = 'Manage firmware'
exports.builder = function (yargs) {

  const epilog = chalk.dim("Darwin Command Line Interface\nCopyright 2026 Darwin Inc. All Rights Reserved.\n")

  return yargs
    .commandDir('firmware_cmds')
    .help()
    .epilog(epilog)
}
exports.handler = function (argv) {}
